import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";

const orderItemsApi = factory.get("orderItems");

const initialState = {
  orderItems: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 15,
      page: 0,
      serial_number: "",
      id: null,
    },
    filter_dialog: false,
  },
};

export const orderItemsSlice = createSlice({
  name: "orderItems",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setOrderItems: (state, action) => {
      state.orderItems.data = action.payload.data.data;
      state.orderItems.total = action.payload.data.total;
    },
    setFilters: (state, { payload }) => {
      state.orderItems.filters = {
        ...state.orderItems.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.orderItems.filters = initialState.orderItems.filters;
    },
    setFilterDialog: (state, action) => {
      state.orderItems.filter_dialog = !state.orderItems.filter_dialog;
    },
  },
});

export const {
  setLoading,
  setOrderItems,
  setFilters,
  setDialog,
  resetForm,
  resetFilters,
  setFilterDialog,
} = orderItemsSlice.actions;
export default orderItemsSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().orderItems.orderItems.filters;
    const _filters = {
      ...filters,
      id: filters.id?.id || null,
    };
    dispatch(setLoading("orderItems"));
    const res = await orderItemsApi.index(_filters);
    dispatch(setOrderItems(res));
    dispatch(setLoading("orderItems"));
  } catch (err) {
    dispatch(setLoading("orderItems"));
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
  }
};

export const OrderItems = {
  index,
};
